import { render } from "./Tile.vue?vue&type=template&id=588ff7de&scoped=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=588ff7de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588ff7de"],['__file',"src/components/Tile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "588ff7de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('588ff7de', __exports__)) {
    api.reload('588ff7de', __exports__)
  }
  
  module.hot.accept("./Tile.vue?vue&type=template&id=588ff7de&scoped=true", () => {
    api.rerender('588ff7de', render)
  })

}


export default __exports__